import { urlRegExp } from 'schemas'
import yup from './yup'

export const sponsorFormSchema = ({ showSponsorshipLevel }) =>
  yup.object().shape({
    fullName: yup
      .string()
      .label('Organization name')
      .trimmedRequired('Organization name is required'),
    booth: yup.string().label('Booth No'),
    websiteUrl: yup
      .string()
      .matches(urlRegExp, 'Website URL must be a valid URL')
      .label('Website URL'),
    intro: yup.string().label('Introduction'),
    sponsorMessage: yup.string().label('Message'),
    sponsorshipLevelId: showSponsorshipLevel
      ? yup.string().label('Sponsorship level').trimmedRequired('Sponsorship level is required')
      : yup.string().label('Sponsorship level'),
    sponsorAdTargetURL: yup
      .string()
      .label('Banner Click URL')
      .matches(urlRegExp, 'Banner click URL must be a valid URL')
  })

export const organizationFormSchema = ({ showSponsorshipLevel }) =>
  yup.object().shape({
    organization: yup
      .string()
      .label('Organization name')
      .trimmedRequired('Organization name is required'),
    booth: yup.string().label('Booth No'),
    sponsorshipLevelId: showSponsorshipLevel
      ? yup.string().label('Sponsorship level').trimmedRequired('Sponsorship level is required')
      : yup.string().label('Sponsorship level'),
    websiteUrl: yup
      .string()
      .trim()
      .test('has-https', 'URL must include the protocol, e.g., https://example.com', (value) => {
        if (!value) return true // handle 'required' separately
        return /^https:\/\//i.test(value)
      })
      .url('Website URL must be a valid URL'),
    bannerClickUrl: yup
      .string()
      .trim()
      .test('has-https', 'URL must include the protocol, e.g., https://example.com', (value) => {
        if (!value) return true // handle 'required' separately
        return /^https:\/\//i.test(value)
      })
      .url('Banner Click URL must be a valid URL'),
    introduction: yup.string().label('Introduction'),
    message: yup.string().label('Message')
  })
